/* global Cookies, attachEvent */

const cookieElement = document.querySelector('.cookie-banner');
const initCookieBanner = () => {
  const cookieElement = document.querySelector('.cookie-banner');
  attachEvent('.btn--cookie', 'click', (ev) => {
    Cookies.set('cookie-banner-seen', 'cookie-set', { expires: 365 });
    cookieElement.classList.remove('cookie-not-set');
    ev.preventDefault();
  });

  attachEvent('.cookie-banner__close', 'click', (ev) => {
    cookieElement.classList.remove('cookie-not-set');
    ev.preventDefault();
  });
}

if (cookieElement) {
  if (!Cookies.get('cookie-banner-seen')) {
    cookieElement.classList.add('cookie-not-set');
  }
  initCookieBanner();
}


function loadScript() {
  // Ckeck if cookie exists
  if (!document.cookie.includes('cookie-banner-seen')) {
    const footer = document.querySelector('footer');
    const cookieBanner = document.createElement('div');
    cookieBanner.classList.add('cookie-banner');
    cookieBanner.classList.add('cookie-not-set');
    function insertAfter(referenceNode, newNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
    const ajax = new XMLHttpRequest();
    const formDataInput = new FormData();
    formDataInput.append('action', 'getCookieBanner');
    ajax.open('POST', localData.siteURL, true);
    ajax.onload = () => {
      const response = JSON.parse(ajax.responseText);
      if (response.data?.status === 200) {
        insertAfter(footer, cookieBanner);
        cookieBanner.innerHTML = response.data.html;
        initCookieBanner();
      }
    };
    ajax.send(formDataInput);
  }
}
// Load with a slight delay
window.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    loadScript();
  }, 100);
});
